import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { interval, Observable } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';

import { environment } from '../environments/environment';

import { MessagePopupComponent } from './popups/message-popup/message-popup.component';
import { PopupFactoryService } from './popups/popup-factory.service';

const VERSION_CHECK_INTERVAL: number = 90000; // 1.5 min;

@Injectable({
  providedIn: 'root',
})
export class VersionCheckerService {
  private version: number = environment.version;

  constructor(
    private popupService: PopupFactoryService,
    private http: HttpClient,
  ) {}

  triggerFirstCheck(): void {
    this.checkVersion()
      .pipe(
        tap((res: { version: number }) => this.handleVersion(res)),
        take(1),
      )
      .subscribe();
  }

  public startChecking(): void {
    this.triggerFirstCheck();
    interval(VERSION_CHECK_INTERVAL)
      .pipe(
        switchMap(() => this.checkVersion()),
        tap((res: { version: number }) => this.handleVersion(res)),
      )
      .subscribe();
  }

  public showPopup(): void {
    this.popupService
      .createPopup({
        popupComponent: MessagePopupComponent,
        popupData: {
          message: 'You are using an outdated version of the application - reload the page to avoid operational problems',
          closeBtnText: 'Reload',
          yellowHeader: true,
          closeWithoutRedirect: true,
        },
        preventBgClick: true,
        hideCloseBtn: true,
      })
      .pipe(take(1))
      .subscribe(() => {
        window.location.reload();
      });
  }

  private handleVersion(res: { version: number }): void {
    if (!res?.version || this.version === res.version) {
      return;
    }

    /* eslint-disable no-console */
    console.log('=== FOUND NEW VERSION ===');
    console.log('Current version: ', this.version);
    console.log('New version: ', res.version);
    /* eslint-enable no-console */

    this.version = res.version;
    sessionStorage.clear();
    this.showPopup();
  }

  private checkVersion(): Observable<any> {
    return this.http.get('/version/');
  }
}
